module.exports = __webpack_public_path__ + "img/heart_bj.a3c3a3d5.png";